module.exports = __webpack_public_path__ + "img/logo.719d21c0.png";